import { render, staticRenderFns } from "./AppScroll.vue?vue&type=template&id=edad0300&scoped=true&"
var script = {}
import style0 from "./AppScroll.vue?vue&type=style&index=0&id=edad0300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edad0300",
  null
  
)

export default component.exports